import { cn } from "@/util/cn";

type PanelCardProps = {
  panels: number;
  capacity: number;
  className?: string;
};
export default function PanelCard({
  panels,
  capacity,
  className,
}: PanelCardProps) {
  return (
    <div
      className={cn(
        "bg-black flex flex-col items-center px-16 py-3 rounded-2xl text-brand-orange-500 gap-1",
        className
      )}
    >
      <p className="text-base">{panels} panels</p>
      <p className="text-sm">{(capacity / 1000).toFixed(1)} kW</p>
    </div>
  );
}
